import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter, RouterProvider,
} from "react-router-dom";

import Sewp5Public from "../../routes/sewp5public";
import ContractHolders from "../../components/ContractHolders/ContractHolders";
import FedRamp from "../../components/FedRamp/FedRamp";
import OrderApp from "../../components/OrderApp/OrderApp";
import ProgramPerformance from "../../components/ProgramPerformance/ProgramPerformance";
import ApprovedContractors from "../../components/ApprovedContractors/ApprovedContractors";

const router = createBrowserRouter([
                                     {
                                       path: "/", element: <Sewp5Public/>, children: [
                                         { path: "sewppublic/contractholders", element: <ContractHolders/> },
                                         { path: "sewppublic/fedramp", element: <FedRamp/> },
                                         { path: "sewppublic/orderapp", element: <OrderApp/> },
                                         { path: "sewppublic/chperformance", element: <ProgramPerformance/> },
                                         { path: "sewppublic/approvedcontractors", element: <ApprovedContractors/> }],
                                     }]);

ReactDOM.createRoot(document.getElementById("root")).render(<React.StrictMode>
  <RouterProvider router={router}/>
</React.StrictMode>);